import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "srcset"]
const _hoisted_2 = { class: "c-article-card__title" }
const _hoisted_3 = { class: "c-article-card__date" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-article-card", _ctx.isTwoColumns ? 'c-article-card--two-columns' : ''])
  }, [
    _createVNode(_component_router_link, {
      to: { name: 'NewsDetail', params: { slug: _ctx.article.slug } },
      class: "c-article-card__link"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["c-article-card__image", { 'c-article-card__image--loaded': _ctx.imageLoaded }])
        }, [
          _createElementVNode("img", {
            loading: "lazy",
            width: "160",
            height: "90",
            src: 
            _ctx.imageUrlBuilder.image(_ctx.article.image).width(800).auto('format').url()
          ,
            srcset: 
            `${_ctx.imageUrlBuilder
              .image(_ctx.article.image)
              .width(300)
              .auto('format')
              .url()} 300w, ` +
            `${_ctx.imageUrlBuilder
              .image(_ctx.article.image)
              .width(800)
              .auto('format')
              .url()} 800w, ` +
            `${_ctx.imageUrlBuilder
              .image(_ctx.article.image)
              .width(1200)
              .auto('format')
              .url()} 1200w`
          ,
            alt: "",
            onLoad: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imageLoaded = true))
          }, null, 40, _hoisted_1)
        ], 2),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.article.title), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDateLong(_ctx.article.date / 1000)), 1)
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ], 2))
}